import {BaseContainerModel} from '../../base-container.model';
import {
  bl_aat_claim_account_entitlement_employee_link_RowClass,
} from '../../../dbschema';

export class ClaimAccountEntitlementEmployeeLinkContainerModel extends BaseContainerModel {
  bl_aat_claim_account_entitlement_employee_link: bl_aat_claim_account_entitlement_employee_link_RowClass = new bl_aat_claim_account_entitlement_employee_link_RowClass();
}
